import React from 'react';
import { Bell, Search, User, ChevronDown } from 'lucide-react';

export const Navbar = () => {
  return (
    <header className="h-20 bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-40 px-8 flex items-center justify-between">
      {/* Search Bar */}
      <div className="relative w-96 hidden md:block">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
        <input 
          type="text" 
          placeholder="Pesquisar..." 
          className="w-full pl-10 pr-4 py-2.5 bg-slate-100 border-none rounded-2xl text-sm focus:ring-2 focus:ring-blue-500/20 transition-all placeholder:text-slate-400"
        />
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-6 ml-auto">
        {/* Notifications */}
        <button className="relative p-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all">
          <Bell size={20} />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
        </button>

        {/* User Profile */}
        <div className="flex items-center gap-3 pl-6 border-l border-slate-200 cursor-pointer group">
          <div className="text-right">
            <p className="text-sm font-bold text-slate-900 group-hover:text-blue-600 transition-colors">Administrador</p>
            <p className="text-[10px] text-slate-500 font-medium uppercase">Admin Master</p>
          </div>
          <div className="w-10 h-10 bg-slate-100 rounded-2xl flex items-center justify-center text-slate-600 group-hover:bg-blue-50 group-hover:text-blue-600 transition-all overflow-hidden border border-slate-200">
            <User size={20} />
          </div>
          <ChevronDown size={14} className="text-slate-400 group-hover:text-blue-600 transition-colors" />
        </div>
      </div>
    </header>
  );
};
